import { t } from "@auto/services";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import styles from "./useraccountrequesttagtypes.module.styl";

export const USER_ACCOUNT_REQUEST_TAG_TYPES = Object.freeze({
  supervisorPasswordMismatch: {
    label: t("geo.tag.supervisorPasswordMismatch"),
    aliases: ["supervisor-password-mismatch", "supervisor_password_mismatch", "supervisor password mismatch"],
    icon: ErrorOutlineOutlinedIcon,
    className: styles.tagSupervisorPasswordMismatch,
    defaultValue: true,
  },
});

export default USER_ACCOUNT_REQUEST_TAG_TYPES;
